<app-role-log
    [config]="config$ | async"
    [roles]="roles$ | async"
    [loading]="loading$ | async"
    [error]="error$ | async">
</app-role-log>
